// Labella cart integration v2: one add request, one feedback owner.
// iCart delegates add-button clicks from body in the capture phase. Give only
// ready eye-picker forms to the theme BEFORE that listener can serialize one id.
// Other products and iCart's own buttons keep their existing handlers.
if (!window.lbLensCartOwnerInstalled) {
  window.lbLensCartOwnerInstalled = true;
  const eyeFormOwner = (form) => {
    const owner = form?.closest?.('product-form');
    if (!owner || owner.form !== form || owner.lbLensPickerVersion !== 1) return null;
    return owner.closest('product-info')?.querySelector('lb-lens-picker[data-ready]') ? owner : null;
  };
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    const button = event.target.closest?.('button, input');
    if (!button || button.type !== 'submit' || !eyeFormOwner(button.form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!button.disabled) button.form.requestSubmit(button);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    const owner = eyeFormOwner(event.target);
    if (!owner) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    owner.onSubmitHandler(event);
  }, true);
}

// Add-to-cart confirmation. This component does not make add requests or expose
// arbitrary line properties (prescription uploads, private notes, etc.).
if (!customElements.get('lb-cart-confirmation')) {
  customElements.define('lb-cart-confirmation', class extends HTMLElement {
    static addedItems(response, formData, boxUnit = false) {
      const requested = [];
      if (formData.get('id')) {
        requested.push({ id: String(formData.get('id')), quantity: Number(formData.get('quantity') || 1), eye: '' });
      } else {
        for (const [key, value] of formData.entries()) {
          const match = /^items\[(\d+)\]\[id\]$/.exec(key);
          if (match) requested.push({ id: String(value), quantity: Number(formData.get(`items[${match[1]}][quantity]`) || 1), eye: formData.get(`items[${match[1]}][properties][Göz]`) || '' });
        }
      }
      const added = Array.isArray(response.items) ? response.items : [response];
      if (!requested.length) throw new Error('Eklenen ürün bilgisi doğrulanamadı. Sepetinizi kontrol edin.');
      return requested.map((request) => {
        const line = added.find((item) => String(item.variant_id || item.id) === request.id);
        if (!line || !Number.isSafeInteger(request.quantity) || request.quantity < 1) {
          throw new Error('Eklenen ürün bilgisi doğrulanamadı. Sepetinizi kontrol edin.');
        }
        // cart/add can return a line's cumulative quantity. Show only the amount
        // submitted by this action, including when the same product was in cart.
        return {
          id: request.id, quantity: request.quantity, unit: boxUnit ? 'kutu' : 'adet',
          title: String(line.product_title || line.title || 'Ürün'),
          image: typeof line.image === 'string' ? line.image : line.featured_image?.url || '',
          eye: String(request.eye),
          options: Array.isArray(line.options_with_values)
            ? line.options_with_values.filter((option) => option.value && option.value !== 'Default Title').map((option) => ({ name: String(option.name || ''), value: String(option.value) }))
            : line.variant_title && line.variant_title !== 'Default Title' ? [{ name: '', value: String(line.variant_title) }] : [],
        };
      });
    }

    static cartAppVisible() {
      const candidate = document.querySelector('#icartMainContent');
      if (!candidate) return false;
      for (let node = candidate; node instanceof Element; node = node.parentElement) {
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      }
      const rect = candidate.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < innerWidth && rect.bottom > 0 && rect.top < innerHeight;
    }

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.innerHTML = `
        <style>
          :host { color: #2b1b1f; font-family: var(--font-body-family, Arial, sans-serif); font-size: 15px; line-height: 1.5; }
          *, *::before, *::after { box-sizing: border-box; }
          dialog { width: min(550px, calc(100vw - 28px)); max-height: calc(100vh - 28px); max-height: calc(100dvh - 28px); padding: 0; margin: auto; border: 1px solid #ead8d0; border-radius: 18px; background: #fffaf7; color: inherit; box-shadow: 0 20px 70px #2b1b1f35; }
          dialog::backdrop { background: #21171b85; }
          dialog[open] { display: flex; flex-direction: column; }
          header { position: relative; flex-shrink: 0; padding: 24px 55px 16px 24px; }
          .success { color: #9f354b; font-size: 14px; font-weight: 600; margin-bottom: 4px; }
          h2 { font-family: var(--font-heading-family, Georgia, serif); font-size: 26px; line-height: 1.2; font-weight: 500; margin: 0 0 8px; }
          .intro, .note { margin: 0; color: #80666c; font-size: 14px; }
          .close { position: absolute; right: 12px; top: 12px; width: 44px; height: 44px; border: 0; border-radius: 50%; color: #59373f; background: transparent; font-size: 28px; cursor: pointer; }
          ul { list-style: none; margin: 0; padding: 0 24px; overflow-y: auto; overscroll-behavior: contain; min-height: 0; }
          li { display: grid; grid-template-columns: 80px minmax(0, 1fr); gap: 14px; padding: 16px 0; border-top: 1px solid #efddd5; }
          .photo { background: #fff; border: 1px solid #efddd5; border-radius: 10px; width: 80px; height: 80px; overflow: hidden; display: grid; place-items: center; color: #80666c; font-size: 12px; }
          img { width: 100%; height: 100%; object-fit: contain; }
          .name { font-weight: 600; margin: 0 0 5px; font-size: 15px; overflow-wrap: anywhere; }
          .option { font-size: 14px; color: #80666c; overflow-wrap: anywhere; }
          .quantity { margin-top: 6px; font-size: 14px; font-weight: 600; }
          footer { padding: 18px 24px 24px; flex-shrink: 0; border-top: 1px solid #efddd5; }
          .note { font-size: 12px; margin-bottom: 14px; }
          .actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
          .action { min-height: 48px; padding: 12px 10px; display: flex; align-items: center; justify-content: center; border-radius: 8px; font: inherit; font-size: 14px; font-weight: 600; text-align: center; cursor: pointer; text-decoration: none; }
          .primary { color: #fff; background: #9f354b; border: 1px solid #9f354b; }
          .secondary { color: #8c2d43; background: #fff; border: 1px solid #c8a2ac; }
          :is(button, a):focus-visible { outline: 2px solid #9f354b; outline-offset: 3px; }
          @media (max-width: 440px) { header { padding: 20px 52px 14px 18px; } ul { padding-inline: 18px; } footer { padding: 16px 18px 18px; } h2 { font-size: 24px; } .actions { grid-template-columns: 1fr; } }
        </style>
        <dialog aria-labelledby="lb-confirm-title" aria-describedby="lb-confirm-intro">
          <header><div class="success" aria-hidden="true">✓ İşlem tamamlandı</div><h2 id="lb-confirm-title">Sepetinize eklendi</h2><p class="intro" id="lb-confirm-intro"></p><button type="button" class="close" aria-label="Pencereyi kapat">×</button></header>
          <ul aria-label="Bu işlemde eklenen ürünler"></ul>
          <footer><p class="note">Kampanya, hediye ve kargo bilgilerini sepetinizde görebilirsiniz.</p><div class="actions"><a class="action primary">Sepete git</a><button type="button" class="action secondary">Alışverişe devam et</button></div></footer>
        </dialog>`;
      this.dialog = this.shadowRoot.querySelector('dialog');
      this.shadowRoot.querySelector('.close').addEventListener('click', () => this.dismiss());
      this.shadowRoot.querySelector('.secondary').addEventListener('click', () => this.dismiss());
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.dismiss(); });
      this.dialog.addEventListener('close', () => this.cleanup());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const targets = [...this.shadowRoot.querySelectorAll('button, a[href]')];
        const first = targets[0], last = targets[targets.length - 1];
        if (event.shiftKey && this.shadowRoot.activeElement === first) { event.preventDefault(); last.focus({ preventScroll: true }); }
        else if (!event.shiftKey && this.shadowRoot.activeElement === last) { event.preventDefault(); first.focus({ preventScroll: true }); }
      });
    }

    async open(items, cartUrl, trigger) {
      // Let an already-active iCart own the feedback. Do not open two carts.
      if (this.constructor.cartAppVisible()) return;
      this.trigger = trigger;
      const list = this.shadowRoot.querySelector('ul');
      list.replaceChildren();
      const total = items.reduce((sum, item) => sum + item.quantity, 0);
      this.shadowRoot.querySelector('.intro').textContent = `${items.length} ürün seçeneği, toplam ${total} ${items.every(item => item.unit === 'kutu') ? 'kutu' : 'adet'} eklendi.`;
      this.shadowRoot.querySelector('.primary').href = cartUrl;
      for (const item of items) {
        const row = document.createElement('li');
        const photo = document.createElement('div'); photo.className = 'photo'; photo.textContent = 'Ürün';
        if (item.image) {
          try {
            const url = new URL(item.image, location.origin);
            if (url.protocol === 'https:' || (url.protocol === 'http:' && location.protocol === 'http:')) {
              const img = document.createElement('img'); img.src = url.href; img.alt = ''; img.width = 80; img.height = 80;
              img.addEventListener('error', () => { photo.textContent = 'Ürün'; }, { once: true });
              photo.replaceChildren(img);
            }
          } catch { /* Keep the neutral placeholder for an invalid image URL. */ }
        }
        const content = document.createElement('div');
        const name = document.createElement('p'); name.className = 'name'; name.textContent = item.title; content.append(name);
        if (item.eye) { const eye = document.createElement('div'); eye.className = 'option'; eye.textContent = item.eye; content.append(eye); }
        for (const option of item.options) {
          const line = document.createElement('div'); line.className = 'option';
          const lower = option.name.toLowerCase();
          const label = ['color', 'colour'].includes(lower) ? 'Renk' : lower === 'sph' ? 'Numara / SPH' : option.name;
          line.textContent = label ? `${label}: ${option.value}` : option.value;
          content.append(line);
        }
        const quantity = document.createElement('div'); quantity.className = 'quantity'; quantity.textContent = `${item.quantity} ${item.unit}`; content.append(quantity);
        row.append(photo, content); list.append(row);
      }
      if (!document.getElementById('lb-confirmation-scroll-style')) {
        const scrollStyle = document.createElement('style'); scrollStyle.id = 'lb-confirmation-scroll-style';
        scrollStyle.textContent = 'html.lb-confirmation-open{overflow:hidden!important}'; document.head.append(scrollStyle);
      }
      document.documentElement.classList.add('lb-confirmation-open');
      try { this.dialog.showModal(); }
      catch { this.dialog.setAttribute('open', ''); }
      this.shadowRoot.querySelector('.secondary').focus({ preventScroll: true });
      this.restoreFocus = true;
      // A delayed iCart auto-open takes ownership instead of leaving two overlays.
      this.appObserver?.disconnect();
      this.appObserver = new MutationObserver(() => {
        if (!this.appFrame) this.appFrame = requestAnimationFrame(() => {
          this.appFrame = null;
          if (this.constructor.cartAppVisible()) { this.restoreFocus = false; this.dismiss(); }
        });
      });
      this.appObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }

    dismiss() {
      if (typeof this.dialog.close === 'function') this.dialog.close();
      else { this.dialog.removeAttribute('open'); this.cleanup(); }
    }

    cleanup() {
      this.appObserver?.disconnect();
      if (this.appFrame) cancelAnimationFrame(this.appFrame);
      this.appFrame = null;
      document.documentElement.classList.remove('lb-confirmation-open');
      if (this.restoreFocus && this.trigger?.isConnected && !this.trigger.disabled) this.trigger.focus({ preventScroll: true });
    }
  });
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.lbSubmitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const showConfirmation = Boolean(this.closest('product-info[id^="MainProduct-"]'));
        const lensPicker = this.closest('product-info')?.querySelector('lb-lens-picker[data-ready]');
        if (lensPicker && !lensPicker.canSubmit()) {
          lensPicker.reportSelectionError();
          return;
        }

        this.lbSubmitting = true;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData;
        try {
          formData = new FormData(this.form);
          if (lensPicker) formData = await lensPicker.prepareFormData(formData);
        } catch (error) {
          this.handleErrorMessage(error.message || 'Seçiminiz doğrulanamadı. Lütfen tekrar deneyin.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          lensPicker?.unlock();
          this.lbSubmitting = false;
          return;
        }
        if (lensPicker || showConfirmation) this.error = false;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (showConfirmation) {
          const sections = new Set(String(formData.get('sections') || '').split(',').filter(Boolean));
          sections.add('cart-icon-bubble');
          formData.set('sections', [...sections].join(','));
          formData.set('sections_url', window.location.pathname);
        }
        config.body = formData;

        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            // Multi-item cart/add responses wrap the added lines in items.
            // Dawn's cart drawer also uses the primary line id for focus handling.
            if (lensPicker && !response.status && response.items?.length && !response.id) {
              response.id = response.items[0].id;
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(lensPicker ? `${response.description || response.message || 'Ürün sepete eklenemedi.'} Tekrar eklemeden önce sepetinizi kontrol edin.` : response.description || response.message || 'Ürün sepete eklenemedi.');

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !showConfirmation) {
              window.location = window.routes.cart_url;
              return;
            }

            const confirmationClass = customElements.get('lb-cart-confirmation');
            const addedItems = showConfirmation ? confirmationClass.addedItems(response, formData, Boolean(lensPicker)) : null;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            if (showConfirmation) {
              this.updateNativeCartSilently(response);
              this.updateCartBubble(response);
              // Select one feedback owner from the successful refresh handoff.
              // iCart may render later or have a zero-sized outer wrapper; its
              // current pixel visibility cannot decide whether to open another
              // modal. Never construct the theme modal after an accepted handoff.
              if (await this.notifyICart(response, formData)) return;
              let confirmation = document.querySelector('lb-cart-confirmation');
              if (!confirmation) {
                confirmation = document.createElement('lb-cart-confirmation');
                document.body.append(confirmation);
              }
              await confirmation.open(addedItems, window.routes.cart_url, this.submitButton);
              return;
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (lensPicker || showConfirmation) {
              this.error = true;
              this.handleErrorMessage('Sepet sonucu doğrulanamadı. Tekrar eklemeden önce sepetinizi kontrol edin.');
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error || showConfirmation) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            lensPicker?.unlock();
            this.lbSubmitting = false;
          });
      }

      async notifyICart(response, formData) {
        // Existing iCart hooks refresh the real cart, gifts and offers, then open
        // its popup. Never submit the native add button or make another add POST.
        const refresh = typeof window.icartCartActivityEvent === 'function'
          ? window.icartCartActivityEvent : window.prepareDataForDisplayWidgetByRule;
        if (typeof refresh !== 'function') return false;
        if (typeof window.icartAddToCartEvent === 'function') {
          for (const line of Array.isArray(response.items) ? response.items : [response]) {
            const id = String(line.variant_id || line.id);
            let quantity = String(formData.get('id')) === id ? Number(formData.get('quantity') || 1) : 0;
            if (!quantity) for (const [key, value] of formData.entries()) {
              const match = /^items\[(\d+)\]\[id\]$/.exec(key);
              if (match && String(value) === id) quantity = Number(formData.get(`items[${match[1]}][quantity]`) || 1);
            }
            if (!Number.isSafeInteger(quantity) || quantity < 1) continue;
            try { window.icartAddToCartEvent({ ...line, quantity }, 'isShopifyAtc'); }
            catch { /* A tracking failure must not block cart refresh. */ }
          }
        }
        try {
          await refresh.call(window);
          return true;
        } catch {
          // This fallback never retries the successful add request.
          return false;
        }
      }

      updateNativeCartSilently(response) {
        // Keep the theme drawer fresh for a later header-icon click, without
        // renderContents(), which would open a second feedback surface.
        if (this.cart?.tagName !== 'CART-DRAWER' || typeof this.cart.getSectionInnerHTML !== 'function') return;
        for (const section of this.cart.getSectionsToRender()) {
          if (section.id === 'cart-icon-bubble') continue;
          const markup = response.sections?.[section.id];
          const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!markup || !target) continue;
          try { target.innerHTML = this.cart.getSectionInnerHTML(markup, section.selector); }
          catch { /* A section failure must not make a successful add look failed. */ }
        }
        this.cart.querySelector?.('#CartDrawer-Overlay')?.addEventListener('click', () => this.cart.close());
      }

      updateCartBubble(response) {
        // iCart owns its icon counter when it is loaded on this theme.
        if (document.querySelector('#icartMainContent')) return;
        const target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        const markup = response.sections?.['cart-icon-bubble'];
        if (typeof markup === 'string' && markup.trim()) {
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const source = parsed.getElementById('cart-icon-bubble') || parsed.getElementById('shopify-section-cart-icon-bubble') || parsed.body;
          target.innerHTML = source.innerHTML;
          return;
        }
        // A section-rendering failure must not turn a successful add into an
        // error or cause an automatic retry. A read-only cart request is safe.
        const root = window.Shopify?.routes?.root || '/';
        fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' })
          .then((result) => result.ok ? result.json() : null)
          .then((cart) => {
            if (!cart || !Number.isSafeInteger(cart.item_count)) return;
            let bubble = target.querySelector('.cart-count-bubble');
            if (!cart.item_count) { bubble?.remove(); return; }
            if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; target.append(bubble); }
            const count = document.createElement('span'); count.setAttribute('aria-hidden', 'true'); count.textContent = String(cart.item_count);
            const accessible = document.createElement('span'); accessible.className = 'visually-hidden'; accessible.textContent = `Sepette ${cart.item_count} ürün`;
            bubble.replaceChildren(count, accessible);
          }).catch(() => {});
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get lbLensPickerVersion() {
        return 1;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
